var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7081 22.0959C34.9262 20.0201 35.4523 17.6106 35.2101 15.2159C34.8521 11.6479 32.8601 8.49394 29.6041 6.33594L27.3941 9.66794C29.6321 11.1519 30.9941 13.2659 31.2301 15.6159C31.339 16.7081 31.203 17.8109 30.8321 18.8439C30.4613 19.8769 29.8648 20.8144 29.0861 21.5879L26.7021 23.9719L29.9381 24.9219C38.4021 27.4019 38.5001 35.9139 38.5001 35.9999H42.5001C42.5001 32.4219 40.5881 25.4299 33.7081 22.0959Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24C23.912 24 27.5 20.412 27.5 16C27.5 11.588 23.912 8 19.5 8C15.088 8 11.5 11.588 11.5 16C11.5 20.412 15.088 24 19.5 24ZM19.5 12C21.706 12 23.5 13.794 23.5 16C23.5 18.206 21.706 20 19.5 20C17.294 20 15.5 18.206 15.5 16C15.5 13.794 17.294 12 19.5 12ZM22.5 26H16.5C9.882 26 4.5 31.382 4.5 38V40H8.5V38C8.5 33.588 12.088 30 16.5 30H22.5C26.912 30 30.5 33.588 30.5 38V40H34.5V38C34.5 31.382 29.118 26 22.5 26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxGroup);
export default __webpack_public_path__ + "static/media/bx-group.7653cd4a645f470281cc9cf565c14e3c.svg";
export { ForwardRef as ReactComponent };